/*
 * Copyright (c) 2020 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */

import FastQuadric from "./FastQuadric/FastQuadric";

export {
  FastQuadric as FastQuadric,
}
